var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.0194 128)",
    className: "st0",
    cx: 128,
    cy: 128,
    rx: 117.1,
    ry: 117.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.9,108.2c0-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3c0,5.7-4.6,10.3-10.3,10.3 C69.5,118.5,64.9,113.9,64.9,108.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M170.4,108.2c0-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3c0,5.7-4.6,10.3-10.3,10.3 C175.1,118.5,170.4,113.9,170.4,108.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 66.5,
    y1: 72.7,
    x2: 93.6,
    y2: 89.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 189.5,
    y1: 72.7,
    x2: 162.4,
    y2: 89.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,208.3c-17.4,0-31.5-19.8-31.5-44.1c0-24.3,14.1-44.1,31.5-44.1s31.5,19.8,31.5,44.1 C159.5,188.5,145.4,208.3,128,208.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/Angry.a7895d4d2c2a3bc01cb5ab805f091b29.svg";
export { ForwardRef as ReactComponent };